import { render, staticRenderFns } from "./ProductsByCategories.vue?vue&type=template&id=726d348c&scoped=true&"
import script from "./ProductsByCategories.vue?vue&type=script&lang=js&"
export * from "./ProductsByCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductsByCategories.vue?vue&type=style&index=0&id=726d348c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d348c",
  null
  
)

export default component.exports